export const createStyles = (theme?: any) => {
  const isDark = theme?.palette?.mode === 'dark';
  const primary = theme?.palette?.primary?.main;
  const highlightedCardBgDark = '#524962';
  const highlightedCardBgLight = '#F0EEF5';
  return {
    cardWrapper: {
      flexShrink: 0,
      px: '16px',
      py: '8px',
      borderRadius: '4px',
      border: `1px solid ${isDark ? '#F8F7F929' : '#231F2929'}`,
      display: 'flex',
      flexDirection: 'column',
      gap: '8px',
      backgroundColor: isDark ? '#3A3444' : '#FFFFFF',
    },
    highlightedCard: {
      backgroundColor: {
        xs: isDark ? highlightedCardBgDark : highlightedCardBgLight,
        md: theme?.palette?.action?.selected,
      },
    },
    cardHeader: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    cardDetails: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'start',
      gap: '8px',
    },
    headerIcon: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: isDark ? '#FFFFFF8F' : '#00000099',
    },
    menuIcon: {
      display: 'flex',
      alignItems: 'center',
      flexShrink: 0,
    },
    status: {
      height: '20px',
      width: 'max-content',
      borderRadius: '100px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      px: '6.5px',
      fontSize: '12px',
      fontWeight: '500',
      backgroundColor: isDark ? '#231F29' : '#F8F7F9',
      color: isDark ? '#F8F7F9' : '#00000099',
    },
    submittedStatus: {
      height: '20px',
      width: 'max-content',
      borderRadius: '100px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      px: '6.5px',
      fontSize: '12px',
      fontWeight: '500',
      backgroundColor: isDark ? '#231F29' : '#F8F7F9',
      color: isDark ? '#66BB6A' : '#2E7D32',
    },
    manualStatus: {
      height: '20px',
      width: 'max-content',
      borderRadius: '100px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      px: '6.5px',
      fontSize: '12px',
      fontWeight: '500',
      backgroundColor: isDark ? '#231F29' : '#F8F7F9',
      color: primary,
      border: `1px solid ${isDark ? '#D0BCFA80' : '#231F2929'}`,
    },
    pastDueDate: {
      height: '20px',
      width: 'max-content',
      borderRadius: '100px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      px: '6.5px',
      fontSize: '12px',
      fontWeight: '500',
      backgroundColor: isDark ? '#FFA726' : '#EF6C00',
      color: isDark ? '#000000DE' : '#FFFFFF',
    },
    title: {
      fontSize: '14px',
      fontWeight: '500',
      minWidth: 0,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
    extensions: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'start',
      gap: '8px',
      px: '10px',
      py: '4px',
      backgroundColor: isDark ? '#231F29' : '#F8F7F9',
      border: `1px solid ${isDark ? '#D0BCFA80' : '#45218880'}`,
      borderRadius: '24px',
      color: primary,
      fontSize: '13px',
      fontWeight: '500',
      width: 'fit-content',
      maxWidth: '100%',
      boxSizing: 'border-box',
    },
    extensionsIcon: {
      height: '18px',
      width: '18px',
      color: primary,
    },
    materials: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'start',
      gap: '8px',
      px: '10px',
      py: '4px',
      backgroundColor: isDark ? '#231F29' : '#F8F7F9',
      border: `1px solid ${isDark ? '#D0BCFA80' : '#45218880'}`,
      borderRadius: '24px',
      color: primary,
      fontSize: '13px',
      fontWeight: '500',
      width: 'fit-content',
      maxWidth: '100%',
      boxSizing: 'border-box',
      cursor: 'pointer',
    },
    materialsIcon: {
      height: '18px',
      width: '18px',
      color: primary,
    },
    materialsTitle: {
      minWidth: 0,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
    materialsCount: {
      flexShrink: 0,
      whiteSpace: 'nowrap',
    },
    endDate: {
      fontSize: '12px',
      color: isDark ? '#FFFFFFB2' : '#00000099',
    },
  };
};
